import fetch from 'isomorphic-fetch';
import { API_URL, API2_URL, NOTIFICATION_MESSAGES_REQUEST, NOTIFICATION_MESSAGES_COMPLETE, NOTIFICATION_STATES_REQUEST, NOTIFICATION_STATES_SAVE,
	NOTIFICATION_MESSAGES_FETCH, NOTIFICATION_MESSAGES_FAIL, NOTIFICATION_MESSAGES_CLEAR, NOTIFICATION_TYPES_FETCH } from "../store/config";
import { newNotification } from "./notifications";
import _ from "lodash";
import {sessionService} from "redux-react-session";
import FileSaver from 'file-saver';

export const notificationMessagesFetch = (modality) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(notificationMessagesRequest());
				dispatch(notificationMessagesClear());

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/notifications/${modality}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(notificationMessagesData(json, modality)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(notificationMessagesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const notificationMessagesExport = (modality) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(notificationMessagesRequest());

				const options = {
					headers: {
						'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};
				let fileName= undefined;

				return fetch(`${API2_URL}/notifications/${modality}?export=1`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							//fileName = result.headers.get('Content-Disposition','attachment')
							let header = result.headers.get('Content-Disposition','attachment')
							fileName = header.match(/filename="(.+)"/)[1];
							//console.log('contentDispositionHeader===>',fileName);
							return result.blob();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						blob => {
							//console.log('blob===>', blob);
							//let today = new Date();
							//let date = today.getFullYear() + ((today.getMonth() + 1) <10 ? `0${today.getMonth() + 1}`:today.getMonth() + 1) + (today.getDate()<10 ? `0${today.getDate()}`:today.getDate()) + today.getHours() + today.getMinutes() + today.getSeconds();
							//FileSaver.saveAs(blob,`Notificaciones_${modality}_${date}.xls`);
							FileSaver.saveAs(blob,fileName);
							dispatch(notificationMessagesComplete());
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(notificationMessagesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const notificationMessagesSave = (values, modality) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(notificationMessagesRequest());
				//let messages=[];

				//_.mapKeys(values.notifications_types, (msg) => messages.push({notification_type_id: msg.id,body: msg.body}));

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({/*messages, */is_test: values.is_test,test_email: values.test_email/*,finished: values.finished*/})
				};

				return fetch(`${API2_URL}/notifications/${modality}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(notificationMessagesRequestSave());
							dispatch(newNotification({title:"Éxito", content: json.message, type: "success"}));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(notificationMessagesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const notificationStateReviewedSave = (value, modality, state) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(notificationStatesRequest());

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({reviewed:value})
				};

				return fetch(`${API2_URL}/notifications/review/${modality}/${state}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(notificationStatesSave());
							//dispatch(newNotification({title:"Éxito", content: json, type: "success"}))
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(notificationMessagesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const notificationAssignFolios = (modality) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post'
				};

				dispatch(notificationMessagesRequest());
				return fetch(`${API_URL}/notifications/review/${modality}/process-codes`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title:"Éxito", content: 'Folios asignados correctamente', type: "success"}))
							return dispatch(notificationMessagesData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(notificationMessagesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const notificationTypesFetch = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(notificationMessagesRequest());
				return fetch(`${API_URL}/notifications/types/current`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(notificationTypesData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(notificationMessagesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

const notificationMessagesData = (json, modality) => {
	let notifications_types = []; let states = [];

	_.mapKeys(json.notifications_types_versions_phases, (item) => {
		return notifications_types.push({ntvp_id: item.id, id: item.notification_type_id, name: item.notification_type.name, body: item.body, modality_id: item.modality_id});
	})

	if(modality === 'modalidad-ii'){
		_.map(json.states, (std) => {
			let review = _.find(std.notifications_agenciables_reviews, {state_id: std.id})
			let stateFind = _.find(json.data, {agency:{agenciable:{state:{id: std.id}}}});
			//console.log('state'+std.name+'====>', stateFind);
			if(stateFind){
				return states.push({
					...std,
					reviewed: review ? review.reviewed:0
				})
			}
		})
	}

	return {
		type: NOTIFICATION_MESSAGES_FETCH,
		isFetching: false,
		payload: {
			list: json.data,
			states: states,
			finished: json.finished,
			notifications_types: notifications_types,
			permissions: json.permissions,
		},
		timestamp: Date.now()
	}
}

const notificationTypesData = (json) => {
	return {
		type: NOTIFICATION_TYPES_FETCH,
		isFetching: false,
		payload: json,
		timestamp: Date.now()
	}
}

const notificationStatesSave = () => {
	return {
		type: NOTIFICATION_STATES_SAVE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const notificationMessagesRequest = () => {
	return {
		type: NOTIFICATION_MESSAGES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const notificationMessagesComplete = () => {
	return {
		type: NOTIFICATION_MESSAGES_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const notificationMessagesRequestSave = () => {
	return {
		type: NOTIFICATION_MESSAGES_REQUEST,
		isFetching: false,
		timestamp: Date.now()
	}
}

const notificationStatesRequest = () => {
	return {
		type: NOTIFICATION_STATES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const notificationMessagesFail = (error) => {
	return {
		type: NOTIFICATION_MESSAGES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

const notificationMessagesClear = () => {
	return {
		type: NOTIFICATION_MESSAGES_CLEAR,
		timestamp: Date.now()
	}
}




// WEBPACK FOOTER //
// ./src/actions/notification_messages.js